module.exports = __webpack_public_path__ + "img/IMG_9519_L_Foamcore_MockedUp.94834749.jpg";